"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIssuePlacement = exports.IssuePlacementContext = void 0;
var _react = require("react");
var _placementUtils = require("./utils/data/placementUtils");
const IssuePlacementContext = exports.IssuePlacementContext = (0, _react.createContext)(undefined);
const useIssuePlacement = () => {
  const defaultLinkGetter = (0, _placementUtils.useDefaultIssuePlacementLink)();
  return (0, _react.useContext)(IssuePlacementContext) || defaultLinkGetter;
};
exports.useIssuePlacement = useIssuePlacement;
//# sourceMappingURL=IssuePlacementContext.js.map